import React from "react";

const Consulting = () => {
  return (
    <div>

      {/* HERO */}
      <section className="hero">
        <div className="container">
          <h1>Business Consulting</h1>
          <p>Professional guidance for business growth</p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="section">
        <div className="container">

          <h2>Our Consulting Services</h2>

          <p>
            We help entrepreneurs and companies in planning,
            compliance and expansion strategies.
          </p>

          <br />

          <div className="grid-3">

            <div className="card">
              <h3>Startup Support</h3>
              <p>Business registration and setup assistance.</p>
            </div>

            <div className="card">
              <h3>Compliance Management</h3>
              <p>Maintain legal and regulatory compliance.</p>
            </div>

            <div className="card">
              <h3>Growth Strategy</h3>
              <p>Expand business with proper planning.</p>
            </div>

          </div>

        </div>
      </section>

    </div>
  );
};

export default Consulting;
